export default {
  placeholder: 'Wybierz tag',
  createTag: 'Utwórz tag zdarzenia',
};
